import { jsx } from "react/jsx-runtime";
const Facebook = ({ className, color = '#181B32', size = 32, ignoreColor })=>/*#__PURE__*/ jsx("svg", {
        className: className,
        xmlns: "http://www.w3.org/2000/svg",
        width: 0.4375 * size,
        height: size,
        viewBox: "0 0 14 32",
        children: /*#__PURE__*/ jsx("path", {
            fill: ignoreColor ? void 0 : color,
            d: "M14.418 10.361h-4.91V7.04c0-1.248.801-1.539 1.365-1.539h3.465V.018L9.565-.001c-5.298 0-6.503 4.089-6.503 6.708v3.655H0v5.65h3.063V32h6.445V16.012h4.347z"
        })
    });
const src_Facebook = Facebook;
export default src_Facebook;
